export default function Icon({image, style}) {
  return <img src={image} alt="icon" style={style}/>
}